import { NUMBER_SANS_COMMAS } from 'common/regex';

const regexFormatter = n => {
  if (typeof n === 'string') {
    n = parseFloat(n);
  }
  if (isNaN(n)) {
    return '';
  } else {
    return `$${n.toFixed(2).toString().replace(NUMBER_SANS_COMMAS, ',')}`;
  }
};

export const getFormatter = () => {
  if (typeof Intl !== 'undefined') {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  } else {
    // Safari 9.x, IE 9/10 don't support Intl
    return { format: regexFormatter, fallback: true };
  }
};

const formatter = getFormatter();

export function toUSD(n) {
  if (n === '' || n === undefined || n === null) {
    return '';
  }
  return formatter.format(n);
}

export function toThousandsSeparator(n) {
  if (n === '' || n === undefined || n === null) {
    return '';
  }

  if (typeof(n) === 'string') {
    n = +n;
  }

  return n.toLocaleString('en-US');
}

// Take string, remove non-numericals(except for decimal), then return the float
export function toFloatInt(str) {
  const type = typeof str;
  if (type === 'number') {
    return str;
  } else if (type === 'string') {
    const num = parseFloat(str.replace(/[^\d.-]/g, ''));
    return isNaN(num) ? undefined : num;
  }
}
